const yup = require("yup");

const deleteRecord = yup.object({
  deleteRecord: yup.string().required("Delete is required"),
});

const password = yup.object({
  firstname: yup.string().required("First name is required"),
  middlename: yup.string(),
  lastname: yup.string().required("Last name is required"),
  emailaddress: yup.string().email("Invalid email address").required("Email is required"),
});

const status = yup.object({
    status: yup.string().required("First name is required"),
    reason: yup.string().required("First name is required"),
  });

module.exports = {
  password,
  deleteRecord,status
};
